<template>
  <!-- 法律聚焦优选推荐 -->
  <div class="cialdetyxtj">
    <div class="detyxtjheader between">
      <div class="FontSize18">优选律师推荐</div>
      <div class="FontSize14 text_hover_shou">更多></div>
    </div>
    <div class="lawlist between wrap">
      <div class="lawitem" v-for="item in 6" :key="item">
        <div class="cov">
          <img src="../../../assets/home/lvshi_lv_sample1.png" />
        </div>
        <div class="text">
           <div class="j"><span>张三</span>律师</div>
          <div class="x">
            <div class="name"><span>张三</span>律师</div>
            <div class="tag">婚姻家庭、劳动合同</div>
            <div class="btn center">点击咨询</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cialdetyxtj {
  width: 100%;
  padding: 0 10px;
  .detyxtjheader {
    padding: 28px 10px 20px;
    border-bottom: 1px solid #eee;
    color: #333333;
  }
  .lawlist {
    padding: 0 10px;
    .lawitem {
      width: 120px;
      height: 128px;
      margin-top: 20px;
      position: relative;
      overflow: hidden;
      box-shadow: 0px 5px 8px 0px rgba(112, 112, 112, 0.1);
      .cov {
        img {
          width: 120px;
          height: 128px;
        }
      }
      .text {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 30px;
        .j {
          font-size: 12px;
          color: #333333;
          line-height: 30px;
          text-align: center;
          background: #ffffff;
          span {
            font-size: 16px;
            margin-right: 3px;
          }
        }

        .x {
          display: none;
          color: #333333;
          text-align: center;
          height: 100%;
          background: #ffffff;
          .name {
            padding-top: 20px;
            span {
              font-size: 16px;
              margin-right: 3px;
            }
          }
          .tag {
            font-size: 12px;
            color: #999999;
            margin-top: 12px;
          }
          .btn {
            width: 68px;
            height: 24px;
            background: #0465ea;
            border-radius: 12px;
            margin: 12px auto 0;
            font-size: 12px;
            color: #ffffff;
          }
        }
      }
      &:hover {
        .text {
          height: 128px;
          transition: all 0.5s;
          .j {
            display: none;
          }
          .x {
            display: block;
          }
        }
      }
    }
  }
}
</style>